import React from "react";

export default function Baccarat29({ data }) {
  const resultDTO = data?.casinoIndividualResultDTO || {};
  const casinoCardResultMaps = resultDTO?.casinoCardResultMaps || [];
  const casinoIndividualResultMaps =
    resultDTO?.casinoIndividualResultMaps || [];

  const getCards = (player) => {
    return (
      casinoCardResultMaps.find((entry) => entry.resultFor === player)
        ?.result || []
    );
  };

  const getResultByType = (resultFor) => {
    const resultObj = casinoIndividualResultMaps.find(
      (item) => item.resultFor === resultFor
    );
    return resultObj ? resultObj.result[0] : "";
  };

  //    const winner = getResultByType("Winner");

  const getWinner = () => {
    const item = casinoIndividualResultMaps.find(
      (el) => el.resultFor === "Winner"
    );
    if (!item) return "";
    return Array.isArray(item.result) ? item.result[0] : item.result;
  };

  const playerACards = getCards("Player A");
  const playerBCards = getCards("Player B");
  const winner = getWinner();

  const matchTime = resultDTO.createdAt
    ? new Date(resultDTO.createdAt + "Z").toLocaleString()
    : "";

  return (
    <div className="modal-dialog modal-xl">
      <div className="modal-content">
       
        <div className="modal-body">
          <div className="casino-result-modal">
            <div className="casino-result-round-id">
              <span>
                <b>Round Id: </b> {resultDTO.marketId}
              </span>
              <span>
                <b>Match Time: </b> {matchTime}
              </span>
            </div>
            <div className="row mt-2">
              <div className="col-md-6 text-center">
                <h4 className="result-title">Player A</h4>
                <div className="casino-result-cards">
                  {winner === "Player A" && (
                    <div className="casino-winner-icon">
                      <i className="fas fa-trophy " />
                    </div>
                  )}
                  {playerACards.map((card, index) => (
                    <img
                      key={index}
                      src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/${card}.jpg`}
                      alt={`Player A card ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
              <div className="col-md-6 text-center">
                <h4 className="result-title">Player B</h4>
                <div className="casino-result-cards">
                  {winner === "Player B" && (
                    <div className="casino-winner-icon">
                      <i className="fas fa-trophy " />
                    </div>
                  )}
                  {playerBCards.map((card, index) => (
                    <img
                      key={index}
                      src={`https://g1ver.sprintstaticdata.com/v51/static/front/img/cards/${card}.jpg`}
                      alt={`Player B card ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
            <div className="row mt-2 justify-content-center">
              <div className="col-md-6">
                <div className="casino-result-desc">
                  <div className="casino-result-desc-item">
                    {/* <div>Winner:</div>
                    <div>{winner}</div> */}
                    <div className="casino-result-desc-item">
                      <div>Winner:</div>
                      <div>{getResultByType("Winner")}</div>
                    </div>
                    <div className="casino-result-desc-item">
                      <div>High Card:</div>
                      <div>{getResultByType("High Card")}</div>
                    </div>
                    <div className="casino-result-desc-item">
                      <div>Pair:</div>
                      <div>{getResultByType("Pair")}</div>
                    </div>
                    <div className="casino-result-desc-item">
                      <div>Color Plus:</div>
                      <div>{getResultByType("Color Plus")}</div>
                    </div>
                    <div className="casino-result-desc-item">
                      <div>Lucky 9:</div>
                      <div>{getResultByType("Lucky 9")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
